import React, { FC } from "react";
import { COLOR_GREY_6 } from "../colors";
import { IconType } from "./types";

export const InfoIcon: FC<IconType> = ({ color = COLOR_GREY_6 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM12.0093 5.97684C12.3613 5.97684 12.6653 6.06218 12.9213 6.23285C13.1773 6.39285 13.3053 6.69685 13.3053 7.14485C13.3053 7.58218 13.1773 7.88618 12.9213 8.05684C12.6653 8.22751 12.3613 8.31285 12.0093 8.31285C11.6467 8.31285 11.3373 8.22751 11.0813 8.05684C10.836 7.88618 10.7133 7.58218 10.7133 7.14485C10.7133 6.69685 10.836 6.39285 11.0813 6.23285C11.3373 6.06218 11.6467 5.97684 12.0093 5.97684ZM12.0013 18.1368C12.6597 18.1368 13.1933 17.6032 13.1933 16.9448V10.5928C13.1933 9.93452 12.6597 9.40085 12.0013 9.40085C11.343 9.40085 10.8093 9.93452 10.8093 10.5928V16.9448C10.8093 17.6032 11.343 18.1368 12.0013 18.1368Z"
      fill={color}
    />
  </svg>
);
